import { render, staticRenderFns } from "./DailymarketComponent.vue?vue&type=template&id=5128a70e"
import script from "./DailymarketComponent.vue?vue&type=script&lang=js"
export * from "./DailymarketComponent.vue?vue&type=script&lang=js"
import style0 from "./DailymarketComponent.vue?vue&type=style&index=0&id=5128a70e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports